import React from "react";
import { Props } from "./types";
import { Report } from "./report";
import styles from "./styles.scss";

function ReportsList({ reports, authorFilter, sort }: Props) {
  return (
    <ul className={styles.reportsList}>
      {reports
        .sort((current, next) =>
          sort === "old"
            ? new Date(current.report.submissionDate) <
              new Date(next.report.submissionDate)
              ? -1
              : 1
            : sort === "new"
              ? new Date(current.report.submissionDate) <
                new Date(next.report.submissionDate)
                ? 1
                : -1
              : 0,
        )
        .filter(({ report }) =>
          authorFilter.length > 0
            ? authorFilter.find(({ name }) => name === report.author)
            : true,
        )
        .map((report) => (
          <li key={report.report.uuid} className={styles.report}>
            <Report report={report} />
          </li>
        ))}
    </ul>
  );
}

export { ReportsList };
